import type { CSSProperties } from 'react';
import { CENTRE_MAX_WIDTH, CENTRE_MIN_WIDTH, MIN_LEADING_WIDTH, TOPBAR_WIDTH_VARS } from './topbar-metrics';

type Props = {
  readonly onHeaderRef: (el: HTMLElement | null) => void;
  readonly onLeadingRef: (el: HTMLDivElement | null) => void;
  readonly onTrailingRef: (el: HTMLDivElement | null) => void;
  // Shell chrome that sits between the two page-owned slots — today the global
  // search entry. Rendered directly rather than portalled, because it belongs to
  // the shell and must not depend on a page filling it.
  readonly centre?: React.ReactNode;
};

// Renders the metrics module's widths as custom properties on the `<header>`,
// so the leading floor and the centre bounds are assertable computed style
// rather than constants no DOM ever reads (BL-121).
const SLOT_WIDTHS = {
  [TOPBAR_WIDTH_VARS.leadingMin]: `${MIN_LEADING_WIDTH}px`,
  [TOPBAR_WIDTH_VARS.centreMin]: `${CENTRE_MIN_WIDTH}px`,
  [TOPBAR_WIDTH_VARS.centreMax]: `${CENTRE_MAX_WIDTH}px`,
} as CSSProperties;

export function Topbar({ onHeaderRef, onLeadingRef, onTrailingRef, centre }: Props) {
  return (
    <header
      ref={onHeaderRef}
      className="flex h-auto min-h-topbar shrink-0 flex-wrap items-center gap-2 py-2 sm:h-topbar sm:flex-nowrap sm:py-0 border-b border-border bg-surface px-4 xl:gap-4"
      style={SLOT_WIDTHS}
    >
      <div
        ref={onLeadingRef}
        className="flex min-w-0 flex-1 basis-full items-center gap-3 overflow-hidden sm:min-w-[var(--topbar-leading-min)] sm:basis-0 [&>span]:truncate"
      />
      {centre !== undefined && (
        <div className="flex shrink-0 justify-center xl:w-full xl:min-w-[var(--topbar-centre-min)] xl:max-w-[var(--topbar-centre-max)] xl:shrink">
          {centre}
        </div>
      )}
      <div ref={onTrailingRef} className="flex shrink-0 items-center gap-2" />
    </header>
  );
}
